// extracted by mini-css-extract-plugin
module.exports = {"dialpadmainconnecting":"numberconnecting_dialpadmainconnecting__28S8w"};